// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContentBox_box__92T3M {
  border: 1px solid #E3E3E3;
  padding: 1rem;
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/ContentBox.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;AACF","sourcesContent":[".box {\n  border: 1px solid #E3E3E3;\n  padding: 1rem;\n  background-color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `ContentBox_box__92T3M`
};
export default ___CSS_LOADER_EXPORT___;
